import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .buttonDeleteMeta {
    width: 2rem !important;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .metaTagsCreativeSelect {
    padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  }

  @media (max-width: 577px) {
    .buttonDeleteMeta {
    }
    .carouselCard {
      padding: 0 !important;
    }
    .carouselCardBody {
      padding: 0 0 1rem 0 !important;
    }
    .bottomMbWeb {
      margin-bottom: 0.5rem;
    }
  }
`;
